/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { PromotionWorkflow } from '../models/promotion-workflow';

/**
 * Ui Promotion Workflow Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiPromotionWorkflowControllerService extends __BaseService {
  static readonly getAllWorkflowsUsingGETPath = '/cc-ui/v1/workflow';
  static readonly createWorkflowUsingPOSTPath = '/cc-ui/v1/workflow';
  static readonly getWorkflowsByStackUsingGETPath =
    '/cc-ui/v1/workflow/blueprint/{stackName}';
  static readonly getDefaultWorkflowUsingGETPath =
    '/cc-ui/v1/workflow/default-workflow/registration-type/{registrationType}';
  static readonly getRegistrationSpecificWorkflowsUsingGETPath =
    '/cc-ui/v1/workflow/registration-specific';
  static readonly getWorkflowUsingGETPath = '/cc-ui/v1/workflow/{workflowId}';
  static readonly updateWorkflowUsingPUTPath =
    '/cc-ui/v1/workflow/{workflowId}';
  static readonly deleteWorkflowUsingDELETEPath =
    '/cc-ui/v1/workflow/{workflowId}';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getAllWorkflows
   * @return OK
   */
  getAllWorkflowsUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<PromotionWorkflow>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/workflow`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PromotionWorkflow>>;
      }),
    );
  }
  /**
   * getAllWorkflows
   * @return OK
   */
  getAllWorkflowsUsingGET(): __Observable<Array<PromotionWorkflow>> {
    return this.getAllWorkflowsUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<PromotionWorkflow>),
    );
  }

  /**
   * createWorkflow
   * @param promotionWorkflow promotionWorkflow
   * @return OK
   */
  createWorkflowUsingPOSTResponse(
    promotionWorkflow: PromotionWorkflow,
  ): __Observable<__StrictHttpResponse<PromotionWorkflow>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = promotionWorkflow;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/workflow`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PromotionWorkflow>;
      }),
    );
  }
  /**
   * createWorkflow
   * @param promotionWorkflow promotionWorkflow
   * @return OK
   */
  createWorkflowUsingPOST(
    promotionWorkflow: PromotionWorkflow,
  ): __Observable<PromotionWorkflow> {
    return this.createWorkflowUsingPOSTResponse(promotionWorkflow).pipe(
      __map((_r) => _r.body as PromotionWorkflow),
    );
  }

  /**
   * getWorkflowsByStack
   * @param stackName stackName
   * @return OK
   */
  getWorkflowsByStackUsingGETResponse(
    stackName: string,
  ): __Observable<__StrictHttpResponse<Array<PromotionWorkflow>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/workflow/blueprint/${encodeURIComponent(String(stackName))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PromotionWorkflow>>;
      }),
    );
  }
  /**
   * getWorkflowsByStack
   * @param stackName stackName
   * @return OK
   */
  getWorkflowsByStackUsingGET(
    stackName: string,
  ): __Observable<Array<PromotionWorkflow>> {
    return this.getWorkflowsByStackUsingGETResponse(stackName).pipe(
      __map((_r) => _r.body as Array<PromotionWorkflow>),
    );
  }

  /**
   * getDefaultWorkflow
   * @param params The `UiPromotionWorkflowControllerService.GetDefaultWorkflowUsingGETParams` containing the following parameters:
   *
   * - `registrationType`: registrationType
   *
   * - `stackName`: stackName
   *
   * @return OK
   */
  getDefaultWorkflowUsingGETResponse(
    params: UiPromotionWorkflowControllerService.GetDefaultWorkflowUsingGETParams,
  ): __Observable<__StrictHttpResponse<PromotionWorkflow>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.stackName != null)
      __params = __params.set('stackName', params.stackName.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/workflow/default-workflow/registration-type/${encodeURIComponent(
          String(params.registrationType),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PromotionWorkflow>;
      }),
    );
  }
  /**
   * getDefaultWorkflow
   * @param params The `UiPromotionWorkflowControllerService.GetDefaultWorkflowUsingGETParams` containing the following parameters:
   *
   * - `registrationType`: registrationType
   *
   * - `stackName`: stackName
   *
   * @return OK
   */
  getDefaultWorkflowUsingGET(
    params: UiPromotionWorkflowControllerService.GetDefaultWorkflowUsingGETParams,
  ): __Observable<PromotionWorkflow> {
    return this.getDefaultWorkflowUsingGETResponse(params).pipe(
      __map((_r) => _r.body as PromotionWorkflow),
    );
  }

  /**
   * getRegistrationSpecificWorkflows
   * @param params The `UiPromotionWorkflowControllerService.GetRegistrationSpecificWorkflowsUsingGETParams` containing the following parameters:
   *
   * - `registrationType`: registrationType
   *
   * - `stackName`: stackName
   *
   * @return OK
   */
  getRegistrationSpecificWorkflowsUsingGETResponse(
    params: UiPromotionWorkflowControllerService.GetRegistrationSpecificWorkflowsUsingGETParams,
  ): __Observable<__StrictHttpResponse<Array<PromotionWorkflow>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.registrationType != null)
      __params = __params.set(
        'registrationType',
        params.registrationType.toString(),
      );
    if (params.stackName != null)
      __params = __params.set('stackName', params.stackName.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/workflow/registration-specific`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<PromotionWorkflow>>;
      }),
    );
  }
  /**
   * getRegistrationSpecificWorkflows
   * @param params The `UiPromotionWorkflowControllerService.GetRegistrationSpecificWorkflowsUsingGETParams` containing the following parameters:
   *
   * - `registrationType`: registrationType
   *
   * - `stackName`: stackName
   *
   * @return OK
   */
  getRegistrationSpecificWorkflowsUsingGET(
    params: UiPromotionWorkflowControllerService.GetRegistrationSpecificWorkflowsUsingGETParams,
  ): __Observable<Array<PromotionWorkflow>> {
    return this.getRegistrationSpecificWorkflowsUsingGETResponse(params).pipe(
      __map((_r) => _r.body as Array<PromotionWorkflow>),
    );
  }

  /**
   * getWorkflow
   * @param workflowId workflowId
   * @return OK
   */
  getWorkflowUsingGETResponse(
    workflowId: string,
  ): __Observable<__StrictHttpResponse<PromotionWorkflow>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/workflow/${encodeURIComponent(String(workflowId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PromotionWorkflow>;
      }),
    );
  }
  /**
   * getWorkflow
   * @param workflowId workflowId
   * @return OK
   */
  getWorkflowUsingGET(workflowId: string): __Observable<PromotionWorkflow> {
    return this.getWorkflowUsingGETResponse(workflowId).pipe(
      __map((_r) => _r.body as PromotionWorkflow),
    );
  }

  /**
   * updateWorkflow
   * @param params The `UiPromotionWorkflowControllerService.UpdateWorkflowUsingPUTParams` containing the following parameters:
   *
   * - `workflowId`: workflowId
   *
   * - `promotionWorkflow`: promotionWorkflow
   *
   * @return OK
   */
  updateWorkflowUsingPUTResponse(
    params: UiPromotionWorkflowControllerService.UpdateWorkflowUsingPUTParams,
  ): __Observable<__StrictHttpResponse<PromotionWorkflow>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.promotionWorkflow;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/workflow/${encodeURIComponent(String(params.workflowId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PromotionWorkflow>;
      }),
    );
  }
  /**
   * updateWorkflow
   * @param params The `UiPromotionWorkflowControllerService.UpdateWorkflowUsingPUTParams` containing the following parameters:
   *
   * - `workflowId`: workflowId
   *
   * - `promotionWorkflow`: promotionWorkflow
   *
   * @return OK
   */
  updateWorkflowUsingPUT(
    params: UiPromotionWorkflowControllerService.UpdateWorkflowUsingPUTParams,
  ): __Observable<PromotionWorkflow> {
    return this.updateWorkflowUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as PromotionWorkflow),
    );
  }

  /**
   * deleteWorkflow
   * @param workflowId workflowId
   * @return OK
   */
  deleteWorkflowUsingDELETEResponse(
    workflowId: string,
  ): __Observable<__StrictHttpResponse<PromotionWorkflow>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/workflow/${encodeURIComponent(String(workflowId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PromotionWorkflow>;
      }),
    );
  }
  /**
   * deleteWorkflow
   * @param workflowId workflowId
   * @return OK
   */
  deleteWorkflowUsingDELETE(
    workflowId: string,
  ): __Observable<PromotionWorkflow> {
    return this.deleteWorkflowUsingDELETEResponse(workflowId).pipe(
      __map((_r) => _r.body as PromotionWorkflow),
    );
  }
}

module UiPromotionWorkflowControllerService {
  /**
   * Parameters for getDefaultWorkflowUsingGET
   */
  export interface GetDefaultWorkflowUsingGETParams {
    /**
     * registrationType
     */
    registrationType: 'ENVIRONMENT' | 'RELEASE_STREAM' | 'HYBRID';

    /**
     * stackName
     */
    stackName?: string;
  }

  /**
   * Parameters for getRegistrationSpecificWorkflowsUsingGET
   */
  export interface GetRegistrationSpecificWorkflowsUsingGETParams {
    /**
     * registrationType
     */
    registrationType: 'ENVIRONMENT' | 'RELEASE_STREAM' | 'HYBRID';

    /**
     * stackName
     */
    stackName?: string;
  }

  /**
   * Parameters for updateWorkflowUsingPUT
   */
  export interface UpdateWorkflowUsingPUTParams {
    /**
     * workflowId
     */
    workflowId: string;

    /**
     * promotionWorkflow
     */
    promotionWorkflow: PromotionWorkflow;
  }
}

export { UiPromotionWorkflowControllerService };
